// client/src/components/shared/SidebarNavigation.tsx

import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/shared.css";

const SidebarNavigation = ({ recentActivity = [], schedule = [], performance = { learningStreak: '0 days', averageScore: '0%' }, onQuickAction, showQuickActions = true, hideLearningSections = false }: any) => {
  const navigate = useNavigate();
  return (
    <aside className="sidebar-navigation">
      {showQuickActions && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontWeight: 700, marginBottom: 8, fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 6 }}>⚡ Quick Actions</div>
          <button onClick={() => onQuickAction ? onQuickAction('/learning') : navigate('/learning')} style={{ width: '100%', marginBottom: 6, background: '#dc2626', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 0', fontWeight: 500, cursor: 'pointer' }}>Start a Lesson</button>
          <button onClick={() => onQuickAction ? onQuickAction('/assignments') : navigate('/assignments')} style={{ width: '100%', marginBottom: 6, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 0', fontWeight: 500, cursor: 'pointer' }}>View Assignments</button>
          <button onClick={() => onQuickAction ? onQuickAction('/resources') : navigate('/resources')} style={{ width: '100%', marginBottom: 6, background: '#059669', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 0', fontWeight: 500, cursor: 'pointer' }}>Access Learning Resources</button>
          <button onClick={() => onQuickAction ? onQuickAction('/grades') : navigate('/grades')} style={{ width: '100%', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 0', fontWeight: 500, cursor: 'pointer' }}>Check Grades</button>
        </div>
      )}
      {!hideLearningSections && (
        <>
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontWeight: 700, marginBottom: 8, fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 6 }}>📝 Recent Activity</div>
            <div style={{ fontSize: '0.95rem', color: '#374151', minHeight: 32 }}>
              {recentActivity.length > 0 ? recentActivity.map((a: any, i: number) => (
                <div key={i} style={{ marginBottom: 4 }}>{a.detail}</div>
              )) : 'No recent activity'}
            </div>
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontWeight: 700, marginBottom: 8, fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 6 }}>📅 Today&apos;s Schedule</div>
            <div style={{ fontSize: '0.95rem', color: '#374151', minHeight: 32 }}>
              {schedule.length > 0 ? schedule.map((slot: any, i: number) => (
                <div key={i} style={{ marginBottom: 4 }}><span style={{ fontWeight: 500 }}>{slot.subject}</span> <span style={{ color: '#6b7280', fontSize: '0.85em' }}>{slot.time}</span></div>
              )) : 'No schedule available'}
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 8, fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 6 }}>📊 Performance</div>
            <div style={{ fontSize: '0.95rem', color: '#374151' }}>
              <div style={{ marginBottom: 4 }}><span style={{ fontWeight: 500 }}>Learning Streak:</span> {performance.learningStreak}</div>
              <div><span style={{ fontWeight: 500 }}>Average Score:</span> {performance.averageScore}</div>
            </div>
          </div>
        </>
      )}
    </aside>
  );
};

export default SidebarNavigation;
